export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_mechanix.png",
      alt: "Nome da extensão",
    },
    title: "Opere com a Mechanix Trading",
    text: [
      "Unimos metodologia científica e tecnologia de execução para automatizar suas operações com precisão e consistência. Nossas estratégias são desenvolvidas para traders e investidores exigentes que preferem decisões baseadas em evidências estatísticas e que buscam praticidade, disciplina e uma execução completamente livre de vieses emocionais. A evolução do seu trading começa aqui.",
    ],
  },
  stats: {
    title: "Mechanix Trading em números",
    subtitle: "Mais de 9 anos de experiência no Mercado Financeiro.",
    data: [
      {
        value: "+9 anos",
        description: " Experiência no Mercado Financeiro",
      },
      {
        value: "+40 mil",
        description: "Linhas de código no Algoritmo Proprietário ",
      },
      {
        value: "+10",
        description: "Diferentes testes de validação por Estratégia",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Mechanix Trading?",
    subtitle: "Veja quais as principais vantagens dos robôs da Mechanix Trading.",
    data: [
      {
        title: "Algoritmos validados",
        description:
          "Nenhuma estratégia chega ao mercado sem passar por um processo rigoroso de backtesting e análise quantitativa.",
      },
      {
        title: "Execução profissional livre de vieses emocionais",
        description:
          "seus trades são executados de forma automatizada, sem interferência de medo, ganância ou impulso.",
      },
      {
        title: "Gestão de risco integrada",
        description:
          "Parâmetros de stop, exposição máxima e controle de drawdown configurados diretamente no algoritmo, protegendo seu capital automaticamente. ",
      },
      {
        title: "Consistência e disciplina",
        description:
          "A estratégia segue as regras do sistema à risca, garantindo consistência operacional ao longo do tempo.",
      },
      {
        title: "Atualizações e evolução contínua",
        description:
          "As estratégias são periodicamente reavaliadas e aprimoradas conforme as condições de mercado evoluem. ",
      },
      {
        title: "Ativação em poucos cliques",
        description:
          "Integração simples via extensão, sem necessidade de conhecimento técnico avançado ou programação. ",
      },
    ],
  },
  cta: {
    title: "Automatize suas operações com estratégias validadas.",
    subtitle: "Ative a extensão e comece a operar com inteligência quantitativa agora mesmo.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Mechanix Trading",
    col1: [
      "A Mechanix Trading nasceu da necessidade de validar e questionar conceitos que são amplamente ensinados como verdades absolutas no mercado financeiro.",
      "Os dados históricos mostram que mais de 95% dos traders de varejo perdem dinheiro consistentemente. No universo dos fundos profissionais, o cenário é igualmente alarmante com estudos mostrando que 94% dos fundos de investimento profissionais ficam abaixo do seu próprio benchmark no longo prazo, e mais da metade nem sobrevive ao período.",
      "O denominador comum de todos esses fracassos é o mesmo: operar com base em técnicas ultrapassadas, opiniões, intuição ou padrões vagos que nunca foram submetidos a validação.",
    ],
    col2: [
      "A verdade é que a maioria dos participantes de mercado negocia sem nenhuma vantagem matemática a seu favor.",
      "Ao questionar conceitos aceitos como dogmas, decidimos testar e comprovar a real eficácia de cada premissa através de metodologia científica e um processo rigoroso de validação.",
      "Focada em substituir opiniões por evidências, a missão da Mechanix é democratizar o acesso a estratégias que realmente possuem expectativa matemática positiva e capturam assimetrias de causa e efeito no mercado. Transformamos o rigor estatístico em tecnologia de execução para que você tome decisões embasadas e sólidas. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Mechanix Trading",
  },
  strategies: {
    title: "Estratégias Mechanix",
    heading: "Inteligência quantitativa ao seu alcance",
    subtitle:
      "Utilize algoritmos de alta performance validados por um processo quantitativo rigoroso. Ative sua estratégia em poucos cliques e opere com o rigor de um trader profissional.",
  },
};
